import React, { ReactNode } from 'react';

import DollarInput from 'components/DollarInput';

import Field from './Field';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const DollarInputField = ({
  name,
  label,
  description,
  mapError,
  placeholder,
  min,
  max,
  ...props
}: {
  name: string;
  label?: ReactNode;
  description?: string;
  errorMessage?: string;
  mapError?: (arg0: string) => ReactNode;
  placeholder?: string;
  min?: number;
  max?: number;
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    mapError={mapError}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <DollarInput
        id={id}
        name={name}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={(e) => {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'EventTarg... Remove this comment to see the full error message
          updateValue(e.target.value);
        }}
        placeholder={placeholder}
        min={min}
        max={max}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    )}
  />
);

// eslint-disable-next-line import/no-default-export
export default DollarInputField;
